export default Object.freeze({
  FREE: 'free', PAID: 'paid',
});
